<script>
const sidebarMenu = [
  { path: "/", icon: "fa fa-th", title: "Home" },
  { path: "/", icon: "fa fa-globe", title: "Utama" },
  {
    path: "/",
    icon: "fa fa-globe",
    title: "dasar",

    children: [
      { path: "/", title: "i-Tegur" },
      { path: "/", title: "Ahli Majlis" },
      { path: "/", title: "PBTPasar " },
      { path: "/", title: "PBTPenguatkuasaan " },
      { path: "/", title: "PBTSenarai " },
      { path: "/", title: "PBT" },
    ],
  },
  {
    path: "/",
    icon: "fa fa-globe",
    title: "pembangunan",

    children: [
      { path: "/", title: "Projek BP.1Bajet" },
      { path: "/", title: "Mengurus" },
    ],
  },
  {
    path: "/",
    icon: "fa fa-globe",
    title: "kesihatan persekitaran",

    children: [
      { path: "/", title: "Cegah Jangkit" },
      { path: "/", title: "VektorPremis" },
      { path: "/", title: "MakananPasar" },
      { path: "/", title: "Awam PBT" },
      { path: "/", title: "Haiwan Terbiar" },
      { path: "/", title: "Kempen" },
    ],
  },
  {
    path: "/",
    icon: "fa fa-globe",
    title: "kejuruteraan kesihatan umum",

    children: [
      { path: "/", title: "Umum" },
      { path: "/", title: "Perangkap Minyak" },
      { path: "/", title: "Kolam Renang" },
      { path: "/", title: "Kolam Takungan Banjir" },
      { path: "/", title: "Lampu Jalan" },
      { path: "/", title: "Hotspot Banjir" },
    ],
  },
  {
    path: "/",
    icon: "fa fa-globe",
    title: "kejuruteraan awam",

    children: [
      { path: "/", title: "OKU" },
      { path: "/", title: "SPAH" },
      { path: "/", title: "Cerun" },
      { path: "/", title: "Jalan" },
      { path: "/", title: "CCTV" },
    ],
  },
  { path: "/", icon: "fa fa-globe", title: "kawalan pemajuan" },
  { path: "/", icon: "fab fa-globe", title: "kampung baru" },
  {
    path: "/",
    icon: "fa fa-th",
    title: "khidmat pengurusan",

    children: [
      { path: "/", title: "Aset" },
      { path: "/", title: "Latihan" },
      { path: "/", title: "Perjawatan" },
      { path: "/", title: "Kewangan" },
      { path: "/", title: "KPI" },
      { path: "/", title: "SKT" },
    ],
  },
  { path: "/", icon: "fa fa-th", title: "pengurusan maklumat" },

  // { path: '/menu', icon: 'fa fa-align-left', title: 'Menu Level',
  //   children: [
  //     { path: '/menu/menu-1-1', title: 'Menu 1.1',
  //       children: [
  //         { path: '/menu/menu-1-1/menu-2-1', title: 'Menu 2.1',
  //           children: [
  //             { path: '/menu/menu-1-1/menu-2-1/menu-3-1', title: 'Menu 3.1' },
  //             { path: '/menu/menu-1-1/menu-2-1/menu-3-2', title: 'Menu 3.2' }
  //           ]
  //         },
  //         { path: '/menu/menu-1-1/menu-2-2', title: 'Menu 2.2' },
  //         { path: '/menu/menu-1-1/menu-2-3', title: 'Menu 2.3' },
  //       ]
  //     },
  //     { path: '/menu/menu-1-2', title: 'Menu 1.2' },
  //     { path: '/menu/menu-1-3', title: 'Menu 1.3' },
  //   ]
  // },
];

export default sidebarMenu;
</script>
